'use client';

import { AppInterface } from '@/enums/app-interface.enum';
import { sendToApp } from '@/lib/app-interface';
import { copyToClipboard } from '@/lib/utils';
import { useMemberStore } from '@/stores/member.store';
import toast, { Toaster } from 'react-hot-toast';
import DetailHeader from '../../components/detail-header';

/**
 * 면허별 수강료 화면의 상단바 — 공유 버튼이 있다.
 *
 * 공유 주소는 **주소창 그대로**(`?license=` 포함)다. 화면은 미들웨어가 내부 경로로
 * rewrite 해 그리지만 주소창은 공개 주소를 유지하므로, 받은 사람이 같은 면허 화면에 닿는다.
 */
export default function PriceShareHeader({
  title,
  fallbackHref,
}: {
  title: string;
  fallbackHref: string;
}) {
  const isAppConnected = useMemberStore((s) => s.isAppConnected);

  const handleShare = async () => {
    const url =
      window.location.origin +
      window.location.pathname +
      window.location.search;

    if (isAppConnected) {
      sendToApp(AppInterface.REQ_ACADEMY_SHARE, {
        title: ' ', // 제목이 있는 경우, 카톡에서 2개 메시지로 나눠서 가는 이슈가 있어서 공백으로 임시 처리
        url,
      });
      return;
    }
    const ok = await copyToClipboard(url);
    toast(
      ok ? 'URL이 클립보드에 복사되었습니다.' : 'URL 복사에 실패했습니다.',
      {
        duration: 2000,
      },
    );
  };

  return (
    <>
      <DetailHeader
        title={title}
        onShare={handleShare}
        fallbackHref={fallbackHref}
      />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: '#363636',
            color: '#fff',
            borderRadius: '100px',
          },
        }}
      />
    </>
  );
}
